import { AppointmentConfiguration } from '../types/AppointmentConfiguration';
import { apiService } from './apiService';
import { NavigateFunction, useNavigate } from 'react-router-dom';


const AppointmentConfigurationService = {
    createAppointmentConfiguration: async (data: AppointmentConfiguration, signal?: AbortSignal) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            
            const response = await apiService.post('/appointment-configuration/', data, {
                headers: {
                    // 'Authorization': `Bearer ${token}`
                },
                signal, 
            });

            return response;

        } catch (error: any) {
            console.error("Error in createPatient:", error);

            return {
                message: error.message || "An error occurred while adding the patient.",
                error,
            };
        }
    },

    getAppointmentConfiguration: async (clinicId: string, signal?: AbortSignal, navigate?: NavigateFunction) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            const response = await apiService.get(`/appointment-configuration/${clinicId}`, {
                headers: {
                    //'Authorization': `Bearer ${token}`
                },
                signal,
            },
                navigate);

            return response; // Make sure response is correctly returned
        } catch (error: any) {

            console.error("Error in get appointment Configuration:", error);

            return {
                message: error.message || "An error occurred while getting the patients.",
                error,
            };
        }
    },

    getAppointmentConfigurationByBookingLinkId: async (bookingLinkId: string, signal?: AbortSignal, navigate?: NavigateFunction) => {
        try {
            const response = await apiService.get(`/appointment-configuration/by-booking-link-id/${bookingLinkId}`,
                {
                    signal,
                },
                navigate
            );

            return response;
        } catch (error: any) {
            console.error("Error in getAppointmentConfigurationByBookingLinkId:", error);

            return {
                message: error.message || "An error occurred while getting the appointment configuration.",
                error,
            };
        }
    },

    updateAppointmentConfiguration: async (appointmentConfigurationId: string, updateData: any, signal?: AbortSignal) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            
            const response = await apiService.patch(`/appointment-configuration/${appointmentConfigurationId}`, updateData, {
                headers: {
                    //'Authorization': `Bearer ${token}`
                },
                signal, 
            });

            return response;
        } catch (error: any) {
            console.error("Error in updatePatient:", error);

            return {
                message: error.message || "An error occurred while updating the patient.",
                error,
            };
        }
    },

};

export default AppointmentConfigurationService;
